// bureau/src/pages/UserCreation/helpers/creation.helper.ts

import { ProfileViaData } from "../types/ProfileViaData";

export const normalizeProfileData = (
  data: Partial<ProfileViaData>,
): Partial<ProfileViaData> => ({
  ...data,
  maritalStatus: data.maritalStatus || "neverMarried",
  religion: data.religion?.toLowerCase() || "",
  caste: data.caste?.trim() || "",
  fullName: data.fullName?.trim() || "",
});
